export default function (obj) {
    var query = Object.keys(obj).map(function (key) {
        return obj[key] !== undefined
            ? key + "=" + encodeURIComponent(obj[key])
            : null;
    });
    return query ? query.filter(Boolean).join('&') : '';
}
